export default __webpack_public_path__ + "static/media/double-spicy.77f452f8.svg";